export const mainWrapperStyles = {
    maxWidth: '1216px',
    width: '95%',
    display: 'flex',
    borderBoxing: 'border-box',
    flexDirection: 'column',
    gap: '16px',
    margin: '32px 0px',
};

export const intakeFormContainerStyles = {
    width: '100%',
    display: 'flex',
    borderBoxing: 'border-box',
    flexDirection: 'column',
    gap: '16px',
    margin: '0px',
};
